import type { SlateBlock } from '@atlas/renderer';
import { Editor, Range, Transforms } from 'slate';
import getNode from '@atlas/tool/box/slate/getNode';
import isTableBlock from '@atlas/tool/box/slate/isTableBlock';
import deleteTablePart from '@atlas/tool/box/slate/deleteTablePart';

export default function deleteBlockPart(editor: Editor, selection: Range) {
    // TODO: @Stan Compare active selection and update it after deleting

    if (selection.anchor.path[0] !== selection.focus.path[0]) {
        throw new Error('Only part of the same block can be removed');
    }

    const path = [selection.anchor.path[0]];
    const block = getNode<SlateBlock>(editor, path);
    if (!block) return;

    if (isTableBlock(block)) return deleteTablePart(editor, selection);

    Transforms.delete(editor, { at: selection });
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('deleteBlockPart', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
